export class HealthRegisterDiploma {
    professionId: string;
    typeId: string;
    placeOfIssue: string;
    countryId: string;
    dateOfIssue: string;
    dateOfRecognition: string;
}
